export default {
  props: {
    specialState: {
      //自定义的store初始状态
      type: Object,
      default: () => ({}),
    },
    specialMutations: {
      //自定义的store初始Mutations
      type: Object,
      default: () => ({}),
    },
    specialActions: {
      //自定义的store初始Actions
      type: Object,
      default: () => ({}),
    },
    queryList: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    buttonsTopKey: {
      type: String,
      default: 'TOP',
    },
    buttonsRowKey: {
      type: String,
      default: 'ROW',
    },
    pageSizeOption: {
      type: Array,
      default: () => [10, 20, 30, 50, 100],
    },
    pageSize: {
      type: Number,
      default: 30,
    },
    // 定义返回数据中的唯一主键属性名。用于多选id值
    dataIdKey: {
      type: String,
      default: 'id',
    },
    selection: {
      type: Boolean,
      default: true,
    },
    defaultSlot: {
      type: Boolean,
      default: true,
    },
    indexLabel: {
      type: String,
      default: '序号',
    },
    emptyButton: {
      type: String,
      default: '查询',
    },
    // 路由跳转编辑地址   // /system/series/edit
    routerEdit: {
      type: String,
      default: null,
    },
    // 删除
    urlRemove: {
      type: String,
      default: null,
    },
    // 批量删除
    urlRemoves: {
      type: String,
      default: null,
    },
    // 查询地址
    urlQuery: {
      type: String,
      require: true,
      default: null,
    },
    // 查询地址-参数
    urlQueryParamter: {
      type: Object,
      default: null,
    },
    // 设置获取明细表传给后台的code
    detailID: {
      type: String,
      default: 'id',
    },
    // 查询请求方式
    urlQueryMethod: {
      type: String,
      default: 'post',
    },
    //查询地址的动态参数
    dynamicParamter: {
      type: [Object, Function],
    },
    // 查询关键词参数名
    searchKey: {
      type: String,
      default: 'keyword',
    },
    // 选中明细的字段集合
    selectedKey: {
      type: String,
      default: '',
    },

    // 表格行级菜单
    tableRowMenu: {
      type: Array,
      default: null,
      //  default: ()=>tableRowMenuDataExample.data.items
    },
    // 查询面菜单
    queryToolbarMenu: {
      type: Array,
      default: null,
      //  default: ()=>queryToolbarMenu.data.items
    },
    customColumn: {
      type: Boolean,
      default: false,
    },
    // 列表定义配置获取URL(配置此参数后tableColDefaultUrl和tableColCode失效)
    tableColumnDefUrl: {
      type: String,
      default: null,
    },
    // 主从表模式的详细列定义
    tableColDetailDefUrl: {
      type: String,
      default: null,
    },
    // 主从表模式的明细请求接口
    urlQueryDetail: {
      type: String,
      default: null,
    },
    // 主从表模式的明细请求接口的请求方式
    urlQueryMethodDetail: {
      type: String,
      default: 'post',
    },
    urlQueryDetailParamter: {
      type: Object,
      default: null,
    },
    //主从模式明细请求的高级查询code
    criteriaDetailCode: {
      type: String,
      default: '',
    },
    //主从模式列表高级查询code
    criteriaCode: {
      type: String,
      default: '',
    },
    tableColDefaultUrl: {
      type: String,
      default: 'rest/main/dict/getTableByCode?tableCode=',
    },
    tableColCode: {
      type: String,
      default: '',
    },
    // 菜单按钮获取URL
    buttonMenuListUrl: {
      type: String,
      default: null,
    },
    // 高级查询动态表单URL
    criteriaFormUrl: {
      type: String,
      default: null,
    },
    // 是否是 topSearch 模式
    isTopSearch: {
      type: Boolean,
      default: false,
    },
    // 列表定义配置
    tableColumnDef: {
      type: Object,
    },

    // 自定义条件保存接口
    saveCriteriaMenuUrl: {
      type: String,
      default: 'rest/ezcomp/dict/criteria/menu/submit',
    },
    // 自定义条件select列表
    selectionMenuUrl: {
      type: String,
      default: 'rest/ezcomp/dict/criteria/menu/options',
    },
    // 自定义条件select列表内容删除
    deleteCriteriaMenuUrl: {
      type: String,
      default: 'rest/ezcomp/dict/criteria/menu/remove',
    },
    // 自定义条件获取表单内容。
    getCriteriaMenuUrl: {
      type: String,
      default: 'rest/ezcomp/dict/criteria/menu/getOfEdit',
    },
    // 自定义条件获取表单内容(预置查询菜单显示个数，超过此参数会显示再)-默认数量为5。
    criteriaMenuOfPresetItemsSpitSize: {
      type: Number,
      default: 5,
    },
    // 扩展对象属性会出现在，绑定模板变量的 extend 中
    extendData: {
      type: Object,
      default: null,
    },
    // 自定义操作栏表头名称
    operateCell: {
      type: String,
      default: '操作',
    },
    initialLoad: {
      type: Boolean,
      default: true,
    },
    showCustomEmpty: {
      type: Boolean,
      default: false,
    },
    cacheQueryKey: {
      type: String,
      default: null,
    },
    ifCacheQuery: {
      type: Boolean,
      default: true,
    },
    // 3751【处方】需要提供处方药品消耗的统计报表方案 记录高级查询条件 默认不急
    recordCriteria: {
      type: Array,
      default: null,
    },
    queryModel: {
      // query 列表模型 模式
      type: Boolean,
      default: false,
    },
    cacheSelection: {
      // 点击分页时，是否缓存选中的数据
      type: Boolean,
      default: true,
    },
    selectionKey: {
      // 分页 缓存选中标志 数据唯一的 标志key
      type: String,
      default: 'id',
    },
    showChainLink: {
      // 是否显示授权链列
      type: Boolean,
      default: false,
    },
    chainLinkCellName: {
      // 授权链列标题
      type: String,
      default: '授权链',
    },
    chainLinkName: {
      // 授权链 Link 显示名称
      type: String,
      default: '查看',
    },
    isShowBtn: {
      // 是否显示btn3
      type: Boolean,
      default: true,
    },
    ifMore: {
      // 是否展开搜索
      type: Boolean,
      default: false,
    },
    urlProgress: {
      type: String,
      default: 'rest/main/progressTask/getAndClearCompleteCache',
    },
    needSideParams: {
      //行级按钮是否添加高级查询的参数
      type: Boolean,
      default: false,
    },
    queryKey: {
      //特殊处理 首页跳转到高耗列表
      type: String,
      default: null,
    },
    //多个参数的情况下
    queryKeys: {
      //特殊处理 首页跳转到高耗列表
      type: Array,
      default: () => [],
    },
    offsetHeight: {
      type: Number,
      default: 0,
    },
    //topSearch 是否要求必填校验
    isValidate: {
      type: Boolean,
      default: false,
    },
    //是否显示右边的按钮组
    isShowRightButton: {
      type: Boolean,
      default: true,
    },
    // 是否保存在localStotage 里面
    // isSetLocalStorageCache: {
    //   type: Boolean,
    //   default: false,
    // },
    //是否显示右边的按钮组
    topDisabled: {
      type: Boolean,
      default: true,
    },
    errorRow: {
      type: Boolean,
      default: false,
    },
    errorRowExpression: [String, Function],
    // #7600，合并并生成新的 selection
    setSelect: { type: Function },
    // #8694，搜索的前置处理
    searchBefore: { type: Function },
  },
}
